//  ----------      START   IMPORT  BLOCK       ----------
import "./listBox.css";
//  ----------      END   IMPORT  BLOCK       ----------

const ListBox2 = ({ items, activeIndex }) => {
  console.log('items', items)
  return (
    <div className="listBoxContainer">
      {items.length === 0 ? (
        <div className="emptyMessage">No items available</div>
      ) : (
        <ul className="listBoxList">
          {items.map((item, index) => (
            <li
              className={`listBoxItem ${index === activeIndex ? "activeItem" : ""}`}
              key={index}
            >
              {item.name}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default ListBox2;
